//#region import
import React, { useEffect, useState } from 'react'
import { Box, Chip, Grid, IconButton, Popover, Tooltip, Typography } from '@mui/material';
import { useLocation, useNavigate } from 'react-router';
import { FnAxios, FnDialog, I18n } from 'utilities/utilities';
import DataGrid, { PaginationInterface, initRows } from 'components/DataGrid';
import { BtnAddOnTable, BtnEditOnTable, BtnViewOnTable } from 'components/Button/ButtonTable';
import DialogPreview from 'components/DialogPreview/DialogPreview';
import { Circle } from '@mui/icons-material';
import { FilterFieldInterface } from 'components/DataGrid/DataGridProps';
import { GetMenuPermission } from 'utilities/SystemFunction';
import { EnumStatus } from '../AdminUser/Role/RoleList';
//#endregion

const UserSystemList = () => {
    const navigate = useNavigate();
    const AxiosFn = FnAxios();
    const DialogFn = FnDialog();
    const location = useLocation();
    const [loadingTable, setLoadingTable] = useState(false);
    const [isOpenPermission, setisOpenPermission] = useState<boolean>(false);
    const [isOpenGroup, setisOpenGroup] = useState<boolean>(false);
    const [lstPermission, setLstPermission] = useState([]);
    const [lstUserGroup, setlstUserGroup] = useState([]);
    const [sUpdateName, setUpdateName] = useState(null);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [arrOrganization, setarrOrganization] = useState<any>([]);
    const [dataRow, setDataRow] = useState<PaginationInterface>({
        ...initRows,
    });


    const [isPermission, setPermission] = useState<boolean>(false); // Permission

    useEffect(() => {
        GetMenuPermission(AxiosFn, setPermission, DialogFn);
    }, []);

    const handleClose = () => {
        setAnchorEl(null);
    };
    const open = Boolean(anchorEl);

    const dataColumn: any = [
        {
            field: "ปุ่ม (เพิ่ม/แก้ไข)",
            align: "center",
            type: "actions",
            resizable: false,
            sortable: false,
            minWidth: 60,
            getActions: (item) => {
                if (!isPermission) {
                    return [
                        <BtnViewOnTable
                            id="btnView"
                            key={item.row.sID}
                            onClick={() => goToEdit(item.row.sID)}
                        />
                    ];
                } else {
                    return [
                        <BtnEditOnTable
                            key={item.row.sID}
                            id="btnEdit"
                            onClick={() => goToEdit(item.row.sID)}
                        />
                    ];
                }
            },

        },
        {
            field: "nNo",
            headerName: "ลำดับ",
            headerAlign: "center",
            align: "center",
            sortable: true,
            minWidth: 80,
            flexl:0.5,

        },
        {
            field: "sUserName",
            headerName: "ชื่อผู้สมัคร",
            headerAlign: "center",
            align: "Left",
            sortable: true,
            minWidth: 350,
            flexl:2,

        },
        {
            field: "sUnitName",
            headerName: "หน่วยงาน",
            headerAlign: "center",
            align: "Left",
            sortable: true,
            minWidth: 250,
        },
        {
            field: "sEmail",
            headerName: "อีเมล",
            headerAlign: "center",
            align: "Left",
            sortable: true,
            minWidth: 250,
        },
        {
            field: "sCreate",
            headerName: "วันที่สมัคร",
            headerAlign: "center",
            align: "center",
            sortable: true,
            minWidth: 200,
        },
        {
            field: "sStatus",
            headerName: "สถานะ",
            headerAlign: "center",
            align: "center",
            sortable: true,
            minWidth: 120,

            renderCell: (item) => {
                return (
                    <>
                        {EnumStatus.Active == item.row.nStatus &&
                            <Tooltip title={item.row.sStatus}>
                                <Chip
                                    size="medium"
                                    label={item.row.sStatus}
                                    style={{
                                        color: "rgb(22 187 68)",
                                        backgroundColor: "rgb(231 255 237)",
                                        margin: "0.2rem",
                                        fontSize: "0.8rem"
                                    }}
                                />
                            </Tooltip>
                        }
                        {EnumStatus.isActive == item.row.nStatus &&
                            <Tooltip title={item.row.sStatus}>
                                <Chip
                                    size="medium"
                                    label={item.row.sStatus}
                                    style={{
                                        color: "#f1416c",
                                        backgroundColor: "#fff5f8",
                                        margin: "0.2rem",
                                        fontSize: "0.8rem"
                                    }}
                                />
                            </Tooltip>
                        }
                    </>
                )
            }
        },
    ];

    const getTableUser = (p: PaginationInterface) => {
        setLoadingTable(true);
        let Param = {
            ...p,
        };
        AxiosFn.Post(`UserSystem/GetTableUser`, Param, (result) => {
            setLoadingTable(false);
            setDataRow({
                ...p,
                arrRows: [...result.lstDataUser],
                nDataLength: result.ObjTable?.nDataLength,
                nPageIndex: result.ObjTable?.nPageIndex,
            });
        });
    };

    const onDelete = (e) => {
        DialogFn.Submit("คุณต้องการลบข้อมูลใช่หรือไม่ ?", () => {
            let objParam = {
                lstID: e,
                sLocation: location.pathname
            }

            AxiosFn.Post(`UserSystem/RemoveDataTable`, objParam, (result) => {
                if (result.nStatusCode === 200) {
                    DialogFn.Success("ลบสำเร็จ", () => {
                        getTableUser(dataRow);
                    });

                }
            });
        });
    };

    const getFormInitial = () => {
        AxiosFn.Get(`UserSystem/GetFormInitial`, {}, (result) => {
            setarrOrganization(result.lstUnitMaster);
        })
    }

    useEffect(() => {
        getTableUser(dataRow);
        getFormInitial();
    }, []);

    const goToEdit = (sID: string) => {
        navigate(`/UserSystemForm?sID=${encodeURI(sID)}`);
    };


    //Filter Search
    const filter: FilterFieldInterface[] = [
        { sTypeFilterMode: "input", sLabel: "ชื่อผู้สมัคร", sFieldName: "sUserName", nGridLG: 6, nGridMD: 6, nGridSM: 6, nGridXS: 12 },
        { sTypeFilterMode: "multiselect", sLabel: "หน่วยงาน", sFieldName: "lstUnit", optionSelect: arrOrganization, nGridLG: 4, nGridMD: 4, nGridSM: 4, nGridXS: 12 },
        { sTypeFilterMode: "date", sLabel: "วันที่แก้ไขข้อมูล (เริ่มต้น)", sFieldName: "nUpdateStart", nGridLG: 3, nGridMD: 3, nGridSM: 4, nGridXS: 12 },
        { sTypeFilterMode: "date", sLabel: "วันที่แก้ไขข้อมูล (สิ้นสุด)", sFieldName: "nUpdateEnd", nGridLG: 3, nGridMD: 3, nGridSM: 4, nGridXS: 12 },
        {
            sTypeFilterMode: "select", sLabel: "สถานะ", sFieldName: "sStatus",
            optionSelect: [
                {

                    label: "ใช้งาน",
                    value: "1"
                },
                {

                    label: "ไม่ใช้งาน",
                    value: "0"
                },

            ],
            nGridLG: 2, nGridMD: 2, nGridSM: 6, nGridXS: 12
        },
    ];
    return (
        <React.Fragment>
            <Grid item xs={12} sx={{ mt: 1 }}>
                <DataGrid
                    sTableID='tb1'
                    columns={dataColumn}
                    rows={dataRow}
                    modeFilter={1}
                    onLoadData={getTableUser}
                    onDelete={onDelete}
                    isLoading={loadingTable}
                    isHiddenToolHead={false}
                    filterField={filter}
                    isShowCheckBox={isPermission}
                    onRowSelectable={(p) => !p.row.isDelete}
                />
            </Grid>

            <DialogPreview
                IsOpen={isOpenPermission}
                IsBackdropClick={false}
                onClose={() => { setisOpenPermission(false); }}
                JsxDialogAction
                CloseSave={false}
                Close={false}
                sMaxWidth='sm'
                bgColor={"#a07300"}
                Color='white'
                Title={'เมนู / ฟังก์ชัน'}

            >
                <Grid container justifyContent={"center"} >
                    {lstPermission.map((m) => (
                        <>
                            <Grid item container xs={12} md={12} spacing={1} sx={{ mt: "5px", marginLeft: 3 }}>
                                <Grid item container md={8} >
                                    <Typography style={{ color: "#212836", fontSize: "16px", fontWeight: m.nfontWeight ? m.nfontWeight : 400 }}> {m.nLevel == 2 && <Circle sx={{ color: "#212836", height: "7px", marginLeft: 2 }} />}{m.sMenuName} </Typography></Grid >
                                <Grid item container md={4} >
                                    <Typography style={{ color: "White", fontSize: "15px", fontWeight: 400 }}>
                                        <Box component="span" sx={{ p: "3px", borderRadius: 1, width: "100%", height: 5, backgroundColor: m.sColor, }}>
                                            &nbsp; {m.sPermissionName} &nbsp;
                                        </Box>
                                    </Typography>
                                </Grid>

                            </Grid>
                        </>
                    ))}

                </Grid>
            </DialogPreview >
            <DialogPreview
                IsOpen={isOpenGroup}
                IsBackdropClick={false}
                onClose={() => { setisOpenGroup(false); }}
                JsxDialogAction
                CloseSave={false}
                Close={false}
                sMaxWidth='sm'
                bgColor={"#a07300"}
                Color='white'
                Title={'กลุ่มผู้ใช้งาน'}
            >
                <Grid container justifyContent={"center"} >
                    {lstUserGroup.map((m) => (
                        <>
                            <Grid item container xs={12} md={12} spacing={1} sx={{ mt: "3px" }}>
                                <Grid item container md={12} >
                                    <Typography style={{ color: "#212836", fontSize: "16px", fontWeight: 500 }}> {<Circle sx={{ color: "#212836", height: "7px", marginLeft: 2 }} />}{m.sGroupName} </Typography></Grid >
                            </Grid>
                        </>
                    ))}

                </Grid>
            </DialogPreview >

            {/* pop over */}
            <Popover
                id={`sUpdateName`}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'center',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
            >
                <Typography sx={{ p: 2 }}>{sUpdateName}</Typography>
            </Popover>
        </React.Fragment >
    )
}
export default UserSystemList;
